// extracted by mini-css-extract-plugin
module.exports = {"castCrewComponentWrapper":"fo","castCrewHeader":"fp","castCrewBody":"fq","castCrewTitle":"fr","slipnslideArrow":"fs"};